export const validateLACode = (account: string) => {
  const validCodes = ["11081", "801", "802", "810", "811", "812", "808", "809", "901", "914", "803", "804", "805", "807", "902"];
  let accountNum = account.replace(/\//g, "").trim();
  let laCode: string;
  const length = accountNum.length;
  let startIndex = length === 16 ? 7 : length > 17 ? 0 : 8;
  let endIndex = length === 16 ? 10 : length > 17 ? 5 : 11;
  laCode = accountNum.substring(startIndex, endIndex);
  return validCodes.some((e) => e === laCode);
};

export const getInfringementNumber = (infringement: string) => {
  const prefix = infringement?.slice(0, 3);
  if (prefix?.trim() === "11/") {
    let formattedInfringementNumber = "11081" + infringement.replace(/\//g, "");
    return formattedInfringementNumber;
  }
  return infringement;
};
